var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconValidationCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assets",
    transform: "translate(-1087.000000, -2486.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/ValidationCheck",
    transform: "translate(1087.000000, 2486.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconValidationCheck"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#7ED321",
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/check"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14789088,11.7006258 C6.99968531,11.8870803 6.78506334,11.9960534 6.55768047,12 L6.54581507,12 C6.32298434,12 6.110228,11.8989199 5.96008217,11.7212445 L3.54170453,8.86579245 C3.24521876,8.51640168 3.26797944,7.97451577 3.59177802,7.65452279 C3.91550197,7.33549632 4.41758007,7.35998106 4.71317033,7.70945237 L6.52671103,9.85033665 L10.9332522,4.30333536 C11.0697417,4.12952593 11.2653342,4.02055274 11.4762996,4.00283352 C11.6863694,3.98422834 11.8955437,4.05784364 12.0556893,4.20604074 C12.2166558,4.35431838 12.315758,4.56630466 12.3312054,4.79303012 C12.3466528,5.02080261 12.2775499,5.24559506 12.1384486,5.41835744 L7.14789088,11.7006258 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconValidationCheck);
export default __webpack_public_path__ + "static/media/iconValidationCheck.93bbff8a.svg";
export { ForwardRef as ReactComponent };